import ProcessDates from '@/resources/constants/process-dates';
import ProcessDatesUtils from '@/resources/utils/process-dates';

const state = {
  isCurrentlyProcessing: false,
  isProcessingPollingHandler: null
};

const getters = {
  isCurrentlyProcessing: state => state.isCurrentlyProcessing
};

const actions = {
  [ProcessDates.Actions.IsProcessing.START] ({ commit }) {
    commit(ProcessDates.Mutations.IsProcessing.START);
  }
};

const isProcessingCheck = function () {
  ProcessDatesUtils.IsProcessing()
    .then(r => { state.isCurrentlyProcessing = r.data; });
};

const mutations = {
  [ProcessDates.Mutations.IsProcessing.START] (state, payload) {
    if (state.isProcessingPollingHandler == null) {
      isProcessingCheck();
      state.isProcessingPollingHandler = setInterval(isProcessingCheck, 60000);
    }
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
